import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-profile-transactional-flag',
  templateUrl: './customer-profile-transactional-flag.component.html',
  styleUrls: ['./customer-profile-transactional-flag.component.css'],
})
export class CustomerProfileTransactionalFlagComponent
  implements OnInit, OnDestroy
{
  transactionMenu: boolean = true;
  customerTransactionForm!: FormGroup;
  roleOnboading: any = '';
  transactionFlag = [
    {
      heading: 'Merchant Hosted Page',
    },
    {
      heading: 'Iframe Payment',
    },
    {
      heading: 'Surcharge',
    },
    {
      heading: 'Retry Transactions',
    },
  ];
  transactionFlag2 = [
    {
      heading: 'Disable CC GST less than Equal to Rs 2000',
    },
    {
      heading: 'Disable DC GST less than Equal to Rs 2000',
    },
    {
      heading: 'UPI Seamless Payment',
    },
    {
      heading: 'UPI Collect Transaction      ',
    },
    {
      heading: 'UPI QR Transaction      ',
    },
    {
      heading: 'UPI Intent Transaction      ',
    },
    {
      heading: 'Payout   ',
    },
    {
      heading: 'Direct Integration Flow     ',
    },
  ];
  orderIDFlag = [
    {
      heading: 'Skip OrderId for Refund',
    },
    {
      heading: 'Allow Duplicate Sale',
    },
    {
      heading: 'Allow Duplicate Refund',
    },
    {
      heading: 'Allow Sale In Refund',
    },
    {
      heading: 'Allow Refund In Sale',
    },
  ];

  refundSetting = [
    {
      heading: 'Enable Auto Refund Post Settlement',
      formControlName: 'EnableAutoRefundPostSettlement',
    },
    {
      heading: 'Allow Refund',
      formControlName: 'AllowRefund',
    },
  ];
  mandatoryParameters = [
    {
      heading: 'Customer Name',
    },
    {
      heading: 'Customer Phone',
    },
    {
      heading: 'Customer Email Id',
    },
    {
      heading: 'Product Description',
    },
  ];
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  userRole: any;
  user: any;
  roles: any;
  singleRole: any;
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.userRole = this.userAuthService.getUserRole();
    this.user = this.userAuthService.getUserDetailsFromSession();
    // this.roleOnboading =
    //   this.userRole == 'partner' || this.userRole == 'reseller'
    //     ? 'Customer'
    //     : 'Partner';
    if (this.userRole == 'partner') {
      this.roleOnboading = 'Reseller';
    }
    if (this.userRole == 'reseller') {
      this.roleOnboading = 'Merchant';
    }
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log(res);
        this.patchCustomerTransactionData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        this.singleRole=res?.role?.type
        this.customerService.sendCustomerFormData(
          this.customerTransactionForm.value
        );
      });
  }

  initForm() {
    this.customerTransactionForm = this.formBuilder.group({
      // DefaultReportingCurrency: ['', Validators.required],
      // PaymentMesageSlab: ['', Validators.required],
      merchantIp: ['', Validators.required],
      payoutWebhookUrl: [
        '',
        [Validators.required, Validators.pattern(this.urlPattern)],
      ],
      settlementType: [''],
      // ExtraRefundAmount: ['', Validators.required],
      // EnableAutoRefundPostSettlement: ['', Validators.required],
      // AllowRefund: ['', Validators.required],
      // EnableNotificationAPI: ['', Validators.required],
      // APIUrl: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      // MerchantPaymentLink: [
      //   '',
      //   [Validators.required, Validators.pattern(this.urlPattern)],
      // ],
      // EnableInstantSettlement: ['', Validators.required],
      // InstantSettlementCharges: ['', Validators.required],
      // EnableAutoSettlement: ['', Validators.required],
      // AutoSettlementCharges: ['', Validators.required],
      settlementDay: ['', Validators.required],
      settlementTime: ['', Validators.required],
    });
  }

  patchCustomerTransactionData(data: any) {
    console.log('customers', data);
    this.roles = data?.role?.type;
    this.customerTransactionForm.patchValue({
      // DefaultReportingCurrency: data.DefaultReportingCurrency,
      // PaymentMesageSlab: data.PaymentMesageSlab,
      merchantIp: data?.merchantConfig?.merchantIp,
      payoutWebhookUrl: data.merchantConfig?.payoutWebhookUrl,
      // ExtraRefundAmount: data.ExtraRefundAmount,
      // EnableAutoRefundPostSettlement: data.EnableAutoRefundPostSettlement,
      // AllowRefund: data.AllowRefund,
      settlementType: data?.settlementConfig?.settlementType,
      // EnableNotificationAPI: data.EnableNotificationAPI,
      // APIUrl: data.APIUrl,
      // MerchantPaymentLink: data.MerchantPaymentLink,
      // EnableInstantSettlement: data.EnableInstantSettlement,
      // InstantSettlementCharges: data.InstantSettlementCharges,
      // EnableAutoSettlement: data.EnableAutoSettlement,
      // AutoSettlementCharges: data.AutoSettlementCharges,
      settlementDay: data?.settlementConfig?.settlementDay,
      settlementTime: data?.settlementConfig?.settlementTime,
    });
    console.log(this.customerTransactionForm);
  }

  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
    console.log('called');
  }

  // Url Validation

  urlPattern =
    '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}' +
    '((\\/[\\w\\-]+)*\\/)?([\\w\\-]+\\.[\\w]{2,4}(\\?[\\w\\-]+=[\\w\\-]+)?)?$';
}
